export const GALLERY = [
  {
    title: "Executive",
    subtitle: "Thoughtfully designed for business travellers and short stays.",
    photos: [
      {
        src: "/assets/executive/01.png",
        alt: "Executive Studio",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/executive/03.png",
        alt: "Executive Studio",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/executive/04.png",
        alt: "Executive Kitchen",
        width: 1200,
        height: 1600,
      },
      {
        src: "/assets/executive/05.png",
        alt: "Executive Studio",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/executive/08.png",
        alt: "Executive Kitchen",
        width: 1200,
        height: 1600,
      },
    ],
  },

  {
    title: "Premium",
    subtitle: "Premium apartments offering extra space and luxury.",
    photos: [
      {
        src: "/assets/premium/25.png",
        alt: "Premium Living",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/premium/31.png",
        alt: "Premium Kitchen",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/premium/27.jpg",
        alt: "Premium Kitchen",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/premium/29.png",
        alt: "Premium Kitchen",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/premium/30.png",
        alt: "Premium Kitchen",
        width: 1600,
        height: 1067,
      },
    ],
  },

  {
    title: "Studio",
    subtitle: "Compact, elegant and perfectly equipped for every stay.",
    photos: [
      {
        src: "/assets/studio/17.png",
        alt: "Executive Workspace",
        width: 1600,
        height: 1067,
      },
      {
        src: "/assets/studio/26.jpg",
        alt: "Premium Bedroom",
        width: 1200,
        height: 1600,
      },
      {
        src: "/assets/studio/20.png",
        alt: "Premium Bedroom",
        width: 1200,
        height: 1600,
      },
      {
        src: "/assets/studio/22.png",
        alt: "Premium Bedroom",
        width: 1200,
        height: 1600,
      },
      {
        src: "/assets/studio/26.jpg",
        alt: "Premium Bedroom",
        width: 1200,
        height: 1600,
      },
    ],
  },
];